export default "__VITE_ASSET__c6e9d84b__"